// Client ↔ bake compatibility (client-bake-compat). A bake names the lowest
// client compat level its artifacts are read correctly by (meta.json
// `client_min`, pipeline/bake2.py, from client/src/compat.json at bake time);
// this client's own level is compat.json `client_compat`. ONE hand-bumped
// integer, not a content hash: a hash would call every client change
// incompatible; the integer moves only when an artifact needs the client.
//
// Pure (no DOM, no JSON import): scripts/check-serve.mjs runs it in Node;
// main.js boot imports the JSON and acts on the verdict — behind → one reload
// (sessionStorage guard keyed by bake + need), still behind → a message and
// no world (the operator's Rebuild client then reloads the page by itself).
// The other way: a bake OLDER than this client reads (`client_min` below
// compat.json `bake_min`, e.g. a pre-R0 bake without GLBQ / WAY1) is 'old' —
// no reload can cure it, main.js shows a message and no world (routes.js
// promoteBlock refuses to make such a bake live).

// 'ok' | 'behind' | 'old'. Every bake names its requirement: `need` absent /
// not a positive integer is a broken meta and throws; `have` not a positive
// integer (cannot happen in a build) is treated as 0 — behind any
// requirement; `min` (compat.json bake_min) not a positive integer reads 1.
export function compatVerdict(have, need, min) {
  if (!Number.isInteger(need) || need < 1) throw new Error(`world meta.client_min missing: ${JSON.stringify(need)}`);
  const h = Number.isInteger(have) && have > 0 ? have : 0;
  if (h < need) return 'behind';
  return need < (Number.isInteger(min) && min > 0 ? min : 1) ? 'old' : 'ok';
}

// the reload guard's sessionStorage key: one automatic reload per (bake,
// requirement) per tab — a dist that is still old after it must not loop
export const compatReloadKey = (bake, need) => `geovr_compat_reload:${String(bake).slice(0, 32)}:${need}`;
